import React from 'react'

import Link from 'gatsby-link'

const Header = (props) => {

	return (

		<header className="uk-position-top uk-light">

			<nav className='trans uk-navbar-container uk-navbar-transparent' data-uk-navbar data-uk-sticky="">
				<a className="uk-link-reset" href="#top" data-uk-scroll><h1 className="uk-navbar-item uk-logo uk-text-uppercase uk-margin-remove">{props.logo}</h1></a>
				<div className="uk-navbar-left uk-visible@s">
					<ul className="uk-navbar-nav" data-uk-scrollspy-nav="closest: li; scroll:true">
						<li><a href="#top">Top</a></li>
						<li><a href="#about">About</a></li>
						<li><a href="#portfolio">Portfolio</a></li>
						<li><a href="#faq">Faq</a></li>
						<li><a href="#contatti">Contatti</a></li>
					</ul>
				</div>
				<div className="uk-navbar-right uk-visible@s">
					<ul className="uk-navbar-nav">
						<li><Link to={"/professionista/cookie-policy?user=" + props.user}>Cookie Policy</Link></li>
						<li><Link to={"/professionista/privacy-policy?user=" + props.user}>Privacy Policy</Link></li>
					</ul>
				</div>
			</nav>

		</header>

	)

}

export default Header



// WEBPACK FOOTER //
// ./src/components/sito/temi/layoutorizzontale/header/index.js